import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAPI } from "../../service/http-service";
import { CommonEndpoint } from "../../service/endpointConfig/CommonEndpoint";

let initialState: any = {
  countryResponse: {},
};

// Get Country API call
export const CountryService = createAsyncThunk(
  "master/country",
  async (country: any) => {
    try {
      return await getAPI(CommonEndpoint.country);
    } catch (err) {
      return err;
    }
  }
);

const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      CountryService.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.status = action.payload?.status;
        state.error = "";
        state.data = action.payload?.data?.data;
      }
    );
    builder.addCase(CountryService.rejected, (state, action) => {
      state.loading = false;
      state.status = -1;
      state.error = action.error.message || "Something went wrong";
      state.data = {};
    });
  },
});

const countryReducer = countrySlice.reducer;
export default countryReducer;
